"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textarea = exports.text = exports.table = exports.select = exports.paragraph = exports.optgroup = exports.list = exports.input = exports.indicator = exports.image = exports.hr = exports.heading = exports.divider = exports.container = exports.button = exports.anchor = exports.abbr = void 0;

var abbr = _interopRequireWildcard(require("./Abbr/abbr.styles"));

exports.abbr = abbr;

var anchor = _interopRequireWildcard(require("./Anchor/anchor.styles"));

exports.anchor = anchor;

var button = _interopRequireWildcard(require("./Button/button.styles"));

exports.button = button;

var container = _interopRequireWildcard(require("./Container/container.styles"));

exports.container = container;

var divider = _interopRequireWildcard(require("./Divider/divider.styles"));

exports.divider = divider;

var heading = _interopRequireWildcard(require("./Heading/heading.styles"));

exports.heading = heading;

var hr = _interopRequireWildcard(require("./HR/hr.styles"));

exports.hr = hr;

var image = _interopRequireWildcard(require("./Image/image.styles"));

exports.image = image;

var indicator = _interopRequireWildcard(require("./Indicator/indicator.styles"));

exports.indicator = indicator;

var input = _interopRequireWildcard(require("./Input/input.styles"));

exports.input = input;

var list = _interopRequireWildcard(require("./List/list.styles"));

exports.list = list;

var optgroup = _interopRequireWildcard(require("./OptGroup/optgroup.styles"));

exports.optgroup = optgroup;

var paragraph = _interopRequireWildcard(require("./Paragraph/paragraph.styles"));

exports.paragraph = paragraph;

var select = _interopRequireWildcard(require("./Select/select.styles"));

exports.select = select;

var table = _interopRequireWildcard(require("./Table/table.styles"));

exports.table = table;

var text = _interopRequireWildcard(require("./Text/text.styles"));

exports.text = text;

var textarea = _interopRequireWildcard(require("./TextArea/textarea.styles"));

exports.textarea = textarea;
//# sourceMappingURL=index.js.map